export default [
  {
    path: "/points/home",
    name: "PointsHome",
    meta: {
      title: "积分商城",
      keepAlive: true,
    },
    component: () => import("@views/points/Home")
  },
  {
    path: "/points/detail/:id",
    name: "PointsDetail",
    meta: {
      title: "积分商品详情",
      keepAlive: true,
    },
    component: () => import("@views/points/Detail")
  },
]
